var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"py-3"},[_vm._v(_vm._s(_vm.$t('admin.alerts.email.editor.preview')))]),_vm._v(" "),_c('div',{staticClass:"email-preview",domProps:{"innerHTML":_vm._s(_vm.computedEmail)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-775ab4f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/alert/EmailPreviewer.vue
// module id = null
// module chunks = 